export default function (initialDataInteractor) {
  return Promise.resolve(
    initialDataInteractor.data.people
  );
}